// Sección del panel admin → módulo que la habilita. Debe coincidir con
// PATH_TO_MODULE de backend/middleware/requireModule.js, que es quien lo aplica
// de verdad (aquí solo se oculta/bloquea en la interfaz). Secciones sin entrada
// son core y siempre están disponibles.
export const SECTION_REQUIRED_MODULE = {
  executive:          'analytics',
  reporting:          'analytics',
  leads:              'leads',
  rates:              'custom_rates',
  certifications:     'certifications',
  shifts:             'shifts',
  maintenance:        'maintenance',
  stock:              'medical_stock',
  patients:           'patient_records',
  quality:            'quality',
  billing:            'billing_adv',
  dispatch:           'dispatch',
  dispatch_map:       'dispatch_map',
  transport_requests: 'dispatch',
  hospitals:          'hospitals',
  insurance:          'insurance',
};

// Lista vacía = solo core (antes "sin gating" abría todo, y el backend no coincidía).
export function isSectionLocked(user, sectionId) {
  if (!user || user.role === 'superadmin') return false;
  const required = SECTION_REQUIRED_MODULE[sectionId];
  if (!required) return false;
  const enabled = Array.isArray(user.enabled_modules) ? user.enabled_modules : [];
  return !enabled.includes(required);
}

export function hasModule(user, slug) {
  if (!user) return false;
  if (user.role === 'superadmin') return true;
  return Array.isArray(user.enabled_modules) && user.enabled_modules.includes(slug);
}
